import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "@/views/Login.vue";
import AdminView from "@/views/AdminView.vue";
import SettingView from "@/views/SettingsView/SettingView.vue";
import ReadinessCatalogsView from "@/views/ReadinessCatalogsView.vue";
import ReadinessEmployeeView from "@/views/ReadinessEmployee.vue";
import ResBadgeHolderView from "@/views/ResBadgeHolderView.vue";
import OrginationPositionView from "@/views/OrginationPositionView.vue";
import DetailEmployeeView from "@/views/DetailEmployeeView.vue";
import EmployeeDetailDashboardView from "@/views/DetailEmployeeViews/EmployeeDetailDashboardView.vue";
import RolePageView from "@/views/RolePageView.vue";
import BeMasterCoachView from "@/views/BeMasterCoachView.vue";
import EmployeeChatterView from "@/views/DetailEmployeeViews/EmployeeChatterView.vue";
import ForgotPasswordView from "@/views/ForgotPasswordView.vue";
import NotificationsListView from "@components/views/NotificationsListView.vue";
import NotFoundView from "@/views/NotFound.vue";
import NewEmployeeView from "@/views/Employees/EmployeeView.vue";
import EmployeeBadges from "@components/EmployeeBadges/EmployeeBadges.vue";
import EmployeeAssignments from "@/views/DetailEmployeeViews/EmployeeAssignmentView.vue";
import PositionView from "@/views/Positions/PositionView.vue";
import store from "../store";
import AsEmployeeNewPage from "@/views/AsEmployeeNewPage.vue";
import AsMaster from "@/views/AsMaster.vue";
import PayRangeListView from "@/views/PayRanges/PayRangeListView.vue";
import DirectoriesView from "@/views/DirectoriesView.vue";
import CatalogDashboard from "@components/CatalogDashboard/CatalogDashboard.vue";
import ReadinessOrganization from "@/views/ReadinessOrganization.vue";
import EmployeePathToRedinessGateway from "@/views/DetailEmployeeViews/EmployeePathToRedinessGateway.vue";
import AsACoachPage from "@components/AsACoachPage/AsACoachPage.vue";
import ChecklistInspectionFormView from "@/views/ChecklistInspectionFormView.vue";
import launchDarklyService from "../services/launchdarkly";
import configService from "../services/config";
import EmployeesOrganizationTable from "@components/EmployeesOrganizationTable/EmployeesOrganizationTable.vue";
import * as Sentry from "@sentry/vue";
import OrganizationPage from "@components/OrganizationPage/OrganizationPage.vue";
import OrganizationLayout from "@components/OrganizationLayout/OrganizationLayout.vue";
import PositionForm from "@components/PositionForm/PositionForm.vue";
import RoleCard from "@components/RoleCard/RoleCard.vue";
import ResponsibilityCard from "@components/ResponsibilityCard/ResponsibilityCard.vue";
import YourStuffPage from "@components/YourStuffPage/YourStuffPage.vue";
import AsEmployeeLayout from "@components/YourStuffPage/AsEmployeeLayout.vue";
import EmployeeResponsibilities from "@components/YourStuffPage/EmployeeResponsibilities.vue";
import EmployeeAssignmentDetail from "@components/YourStuffPage/EmployeeAssignmentDetail.vue";
import YourStuffEmployeeBadges from "@components/YourStuffPage/EmployeeBadges.vue";
import AsCoachView from "@components/YourStuffPage/AsCoachView.vue";
import AsMasterView from "@components/YourStuffPage/AsMasterView.vue";
import NewReadiness from "@/views/NewReadiness/NewReadiness.vue";
Vue.use(VueRouter);

const checkMyStuffMiddleware = (to, from, next) => {
  const currentAccount = JSON.parse(localStorage.getItem("accessPermission"));
  if (
    Object.prototype.hasOwnProperty.call(currentAccount, "has_employee") &&
    currentAccount.has_employee === true
  ) {
    next();
  } else {
    next({ name: "Employees" });
  }
};

const checkReadinessOrganizationMiddleware = async (to, from, next) => {
  try {
    // Check if the feature flag is enabled
    const showReadinessOrganizationTab = await launchDarklyService.getFlag(
      "hide_organizational_readiness",
      false
    );

    if (showReadinessOrganizationTab) {
      next();
    } else {
      // Redirect to readiness employees if organization tab is disabled
      next({ name: "Positions" });
    }
  } catch (error) {
    console.error("Error checking readiness organization flag:", error);
    // Default to allowing access if flag check fails
    next();
  }
};

const routes = [
  {
    path: "/",
    name: "",
    component: LoginView, // Won't actually render, beforeEach will redirect
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/organization/employees",
    name: "Employees",
    component: NewEmployeeView,
  },
  {
    path: "/organization/employees/:id(\\d+)",
    name: "DetailEmployee",
    component: DetailEmployeeView,
    meta: { secondSidebar: "employee" },
    children: [
      {
        path: "/organization/employees/:id(\\d+)/dashboard",
        name: "DetailEmployeeDashboard",
        component: EmployeeDetailDashboardView,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/organization/employees/:id(\\d+)/pathtoreadiness",
        name: "EmployeePathToReadiness",
        component: EmployeePathToRedinessGateway,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/organization/employees/:id(\\d+)/chatter",
        name: "EmployeeChatter",
        component: EmployeeChatterView,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/organization/employees/:id/assignment",
        name: "EmployeeAssignments",
        component: EmployeeAssignments,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/organization/employees/:id(\\d+)/badges",
        name: "EmployeeBadges",
        component: EmployeeBadges,
        meta: { secondSidebar: "employee" },
      },
    ],
  },
  {
    path: "/new-organization/employees/:id(\\d+)",
    name: "NewOrganizationDetailEmployee",
    component: DetailEmployeeView,
    meta: { secondSidebar: "employee" },
    children: [
      {
        path: "/new-organization/employees/:id(\\d+)/dashboard",
        name: "NewOrganizationDetailEmployeeDashboard",
        component: EmployeeDetailDashboardView,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/new-organization/employees/:id(\\d+)/pathtoreadiness",
        name: "NewOrganizationEmployeePathToReadiness",
        component: EmployeePathToRedinessGateway,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/new-organization/employees/:id(\\d+)/chatter",
        name: "NewOrganizationEmployeeChatter",
        component: EmployeeChatterView,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/new-organization/employees/:id/assignment",
        name: "NewOrganizationEmployeeAssignments",
        component: EmployeeAssignments,
        meta: { secondSidebar: "employee" },
      },
      {
        path: "/new-organization/employees/:id(\\d+)/badges",
        name: "NewOrganizationEmployeeBadges",
        component: EmployeeBadges,
        meta: { secondSidebar: "employee" },
      },
    ],
  },
  {
    path: "/organization/positions",
    name: "Positions",
    component: PositionView,
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminView,
    meta: {
      sideBarPresent: false,
      le: "admin",
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: SettingView,
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswrd",
    component: ForgotPasswordView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/setup/password",
    name: "SetNewPassword",
    component: ForgotPasswordView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/reset/password",
    name: "SetNewPasswordReset",
    component: ForgotPasswordView,
    meta: { hideMainSidebar: true },
  },
  {
    path: "/my-stuff/employee",
    name: "AsEmployee",
    component: AsEmployeeNewPage,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/my-stuff/master",
    name: "AsMaster",
    component: AsMaster,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/my-stuff/coach",
    name: "AsCoach",
    component: AsACoachPage,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/my-stuff/coach/inspection/:employeeId/:responsibilityId",
    name: "ChecklistInspection",
    component: ChecklistInspectionFormView,
    beforeEnter: checkMyStuffMiddleware,
  },
  {
    path: "/directories",
    name: "Directories",
    component: DirectoriesView,
  },
  {
    path: "/readiness/catalogs",
    name: "ReadinessCatalogs",
    component: ReadinessCatalogsView,
  },
  {
    path: "/readiness/catalogs/:type(\\w+)",
    name: "ReadinessCatalogsDetail",
    component: ReadinessCatalogsView,
  },
  {
    path: "/readiness/catalogs/responsibilities/:objId(\\d+)",
    name: "ReadinessCatalogsDetailObjId",
    component: ResBadgeHolderView,
  },
  {
    path: "/new-organization/responsibilities/responsibility/:resId(\\d+)/:tab?",
    name: "ResponsibilityCard",
    component: ResponsibilityCard,
  },
  {
    path: "/my-stuff/master/responsibilities/:objId(\\d+)",
    name: "AsMasterResponsibilities",
    component: ResBadgeHolderView,
  },
  {
    path: "/readiness/catalogs/roles/:objId(\\d+)",
    name: "ReadinessCatalogsDetailObjId",
    component: RolePageView,
  },
  {
    path: "/readiness/employees",
    name: "ReadinessEmployees",
    component: ReadinessEmployeeView,
  },
  {
    path: "/readiness/organization",
    name: "ReadinessOrganization",
    component: ReadinessOrganization,
    beforeEnter: checkReadinessOrganizationMiddleware,
  },
  {
    path: "/readiness/responsibility/holder/:resId(\\d+)",
    name: "ResBadgeHolder",
    component: ResBadgeHolderView,
  },
  {
    path: "/organization/positions/position/:pId(\\d+)",
    name: "OrgPosition",
    component: OrginationPositionView,
  },
  {
    path: "/new-organization/positions/position/:pId(\\d+)",
    name: "OrgPosition",
    component: OrginationPositionView,
  },
  {
    path: "/readiness/catalogs/roles/:type(\\w+)/:objId(\\d+)",
    name: "ReadinessCatalogsRolesResponse",
    component: ResBadgeHolderView,
  },
  {
    path: "/readiness/catalogs/roles/:roleId(\\d+)/:type(\\w+)/:objId(\\d+)",
    name: "ReadinessCatalogsRolesResponse",
    component: ResBadgeHolderView,
  },
  {
    path: "/readiness/catalogs/roles/:roleId(\\d+)/attach/:type(\\w+)/:objId(\\d+)",
    name: "ReadinessCatalogsResponsibilityResponse",
    component: ResBadgeHolderView,
  },
  {
    path: "/organization/positions/:pId(\\d+)/:type(\\w+)/:objId(\\d+)",
    name: "OrgPositionDetailObjId",
    component: RolePageView,
  },
  {
    path: "/organization/positions/:pId(\\d+)/roles/:roleId(\\d+)/:type(\\w+)/:objId(\\d+)",
    name: "OrgPositionRolesResponse",
    component: ResBadgeHolderView,
  },
  {
    path: "/services/be-master-coach",
    name: "BeMasterCoach",
    component: BeMasterCoachView,
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: NotificationsListView,
  },
  {
    path: "/compensation/pay-range-list",
    name: "PayRangeList",
    component: PayRangeListView,
  },
  {
    path: "/catalog-dashboard",
    name: "CatalogDashboard",
    component: CatalogDashboard,
  },
  {
    path: "/organization/employees-organization-table",
    name: "EmployeesOrganizationTable",
    component: EmployeesOrganizationTable,
  },
  {
    path: "/new-organization/positions/:positionId",
    name: "PositionDetail",
    component: OrganizationLayout,
    children: [
      {
        path: "",
        name: "PositionDetailChild",
        component: PositionForm,
      },
      {
        path: "roles/:roleId",
        name: "RoleDetailFromPosition",
        component: RoleCard,
        props: (route) => ({
          roleId: route.params.roleId,
          breadcrumbsList: [
            {
              text: "Positions",
              disabled: false,
              href: "/new-organization/positions",
            },
            {
              text: route.query.positionName || "Position",
              disabled: false,
              icon: "org_icon_position",
              positionId: route.params.positionId,
            },
            {
              text: "Role",
              disabled: true,
            },
          ],
        }),
      },
    ],
  },
  {
    path: "/new-organization/roles/:roleId",
    name: "RoleDetail",
    component: OrganizationLayout,
    children: [
      {
        path: "",
        name: "RoleDetailChild",
        component: RoleCard,
        props: (route) => ({
          roleId: route.params.roleId,
          breadcrumbsList: [
            {
              text: "Roles",
              disabled: false,
              href: "/new-organization/roles",
            },
            {
              text: "Role",
              disabled: true,
            },
          ],
        }),
      },
    ],
  },
  {
    path: "/new-organization/responsibilities/:resId",
    name: "ResponsibilityDetail",
    component: OrganizationLayout,
    children: [
      {
        path: "",
        name: "ResponsibilityDetailChild",
        component: ResponsibilityCard,
        props: (route) => ({
          resId: route.params.resId,
        }),
      },
    ],
  },
  {
    path: "/new-organization/positions/:positionId/roles/:roleId/responsibilities/:resId",
    name: "ResponsibilityDetailFromPositionRole",
    component: OrganizationLayout,
    children: [
      {
        path: "",
        name: "ResponsibilityDetailFromPositionRoleChild",
        component: ResponsibilityCard,
        props: (route) => ({
          resId: route.params.resId,
        }),
      },
    ],
  },
  {
    path: "/new-organization/roles/:roleId/responsibilities/:resId",
    name: "ResponsibilityDetailFromRole",
    component: OrganizationLayout,
    children: [
      {
        path: "",
        name: "ResponsibilityDetailFromRoleChild",
        component: ResponsibilityCard,
        props: (route) => ({
          resId: route.params.resId,
        }),
      },
    ],
  },
  {
    path: "/new-organization",
    redirect: "/new-organization/dashboard",
  },
  {
    path: "/new-organization/:tab",
    name: "NewOrganization",
    component: OrganizationPage,
  },
  {
    path: "/new-readiness",
    name: "NewReadiness",
    component: NewReadiness,
  },
  {
    path: "/new-my-stuff",
    name: "NewMyStuff",
    component: YourStuffPage,
    redirect: "/new-my-stuff/employee/responsibilities",
    children: [
      {
        path: "employee",
        name: "AsEmployee",
        component: AsEmployeeLayout,
        redirect: "/new-my-stuff/employee/responsibilities",
        children: [
          {
            path: "responsibilities",
            name: "EmployeeResponsibilities",
            component: EmployeeResponsibilities,
          },
          {
            path: "responsibilities/:assignmentId",
            name: "EmployeeAssignmentDetail",
            component: EmployeeAssignmentDetail,
          },
          {
            path: "badges",
            name: "YourStuffEmployeeBadges",
            component: YourStuffEmployeeBadges,
          },
        ],
      },
      {
        path: "coach",
        name: "AsCoachNew",
        component: AsCoachView,
      },
      {
        path: "master",
        name: "AsMasterNew",
        component: AsMasterView,
      },
    ],
  },
  {
    path: "/404",
    name: "NotFound",
    component: NotFoundView,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/forgot-password",
    "/setup/password",
    "/reset/password",
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn =
    localStorage.getItem("token") && localStorage.getItem("currentAccountID");
  // Check if user has employee object in localStorage
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;
  const hasEmployeeAccess = user?.employee;
  store.dispatch("routeErrorHandling/clearError");
  if (authRequired && !loggedIn) {
    if (to.fullPath == "/") {
      return next("/login");
    } else {
      Sentry.setUser(null);
      configService.clearSecureConfig();
      localStorage.clear();
      launchDarklyService.resetToAnonymous();
      return next({ path: "/login", query: { nextUrl: to.fullPath } });
    }
  }
  if (to.fullPath == "/" && loggedIn) {
    if (hasEmployeeAccess) {
      return next({ name: "AsEmployee" });
    } else {
      return next({ name: "NewOrganization", params: { tab: "Dashboard" } });
    }
  }
  if (!authRequired) {
    Sentry.setUser(null);
    configService.clearSecureConfig();
    localStorage.clear();
    launchDarklyService.resetToAnonymous();
  }
  sessionStorage.setItem("navigated", from.name);
  next();
});

export default router;
